import React from 'react';
import { translate } from 'react-i18next';

import PasswordFieldWithValidation from 'components/PasswordFieldWithValidation.js';
import ConfirmableFieldPair from 'components/ConfirmableFieldPair.js';
import UIStatusDialog from 'components/UIStatusDialog.js';
import AccountActions from 'actions/AccountActions.js';

class PasswordChange extends React.Component {
  constructor(props) {
    super(props);

    this.onUserInput = this.onUserInput.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);

    this.initialState = {
      statuses: [],
      current_password: {
        valid: false,
        inputClass: 'initialized',
        value: '',
      },
      password: {
        valid: false,
        inputClass: 'initialized',
      },
      password_confirmation: {
        valid: false,
        inputClass: 'initialized',
      },
      errors: '',
      valid: false,
    };
    this.state = this.initialState;
  }

  componentWillUnmount() {
    AccountStore.off(null, null, this);
  }

  componentDidMount() {
    if (this.props.password_preferences) {
      this.setState(this.props.password_preferences);
    }

    AccountStore.on(
      'password:update:failed',
      function (data) {
        for (const i in data.fields) {
          const field = data.fields[i];
          const message = data.errors[i];
          this.setState({
            [field]: {
              valid: false,
              value: this.state[field].value,
              inputClass: 'error',
              errorMessage: message,
            },
          });
        }
      },
      this,
    );

    AccountStore.on(
      'password:update:success',
      function (data) {
        this.setState(this.initialState);
      },
      this,
    );
  }

  handleUpdate(e) {
    e.preventDefault();
    const isFormValid = this.state.current_password.valid
      && this.state.password.valid
      && this.state.password_confirmation.valid;
    if (isFormValid) {
      this.setState({ valid: true });
      AccountActions.updatePassword(
        this.props.user.id,
        this.state.current_password.value,
        this.state.password.value,
      );
    } else {
      this.validateInputs();
    }
  }

  generateErrors() {
    const values = [
      this.state.current_password.value,
      this.state.password.value,
      this.state.password_confirmation.value,
    ];
    for (const value of values) {
      if (value == '') {
        return this.props.t('AccountPassword.all_fields_required');
      }
    }

    if (this.props.passwordPreferences) {
      if (this.state.current_password.value == '') {
        return this.props.t('AccountPassword.supply_current_password');
      }

      if (this.state.password.value != this.state.password_confirmation.value) {
        return this.props.t('AccountPassword.password_does_not_match');
      }
    }
  }

  validateInputs() {
    let valid = this.allInputsValid();
    valid = this.state.current_password.valid
      && this.state.password.valid
      && this.state.password_confirmation.valid;
    const errorMessage = valid ? '' : this.generateErrors();

    this.setState({
      valid,
      errors: errorMessage,
    });
  }

  allInputsValid() {
    return (
      this.state.current_password.valid
      && this.state.password.valid
      && this.state.password_confirmation.valid
    );
  }

  onUserInput(name, value, valid) {
    this.setState({
      [name]: {
        valid,
        value,
        inputClass: this.toggleInputClass(valid),
      },
    });
  }

  handleCurrentPasswordChange(value, valid) {
    this.setState({
      current_password: {
        inputClass: this.toggleInputClass(valid),
        value,
        valid,
      },
    });
  }

  toggleInputClass(bool) {
    return bool ? 'valid' : 'error';
  }

  currentPasswordInputclass() {
    return this.state.current_password.inputClass;
  }

  closeStatusDialog(props) {
    this.props.closeStatusDialog(props);
  }

  render() {
    let passwordConfirmed = false;
    const currentPasswordValue = this.state.current_password.value;

    if (
      this.state.password.valid
      && this.state.password_confirmation.value == this.state.password.value
    ) {
      passwordConfirmed = true;
    }

    const cannotBeBlank = [{ key: this.props.t('AccountPassword.cannot_be_blank'), pattern: /.*\S.*/ }];
    const min8Characters = [{ key: this.props.t('AccountPassword.minimum_8_characters'), pattern: /^.{8,}$/ }];

    const allValid = this.state.current_password.valid
      && this.state.password.valid
      && this.state.password_confirmation.valid;

    const statusDialogs = [];
    for (let i = 0; i < this.props.statuses.length; i++) {
      statusDialogs.push(
        <UIStatusDialog
          status={this.props.statuses[i]}
          key={_.uniqueId()}
          closeDialog={this.closeStatusDialog.bind(this)}
        />,
      );
    }

    return (
      <div className={this.props.activeState}>
        <form className="contact-info password-change" onSubmit={this.handleUpdate}>
          <fieldset>
            <legend>
              <h1>Password</h1>
            </legend>
            <PasswordFieldWithValidation
              inputClass={this.currentPasswordInputclass()}
              name="current_password"
              label={this.props.t('AccountPassword.current_password')}
              placeholder={this.props.t('AccountPassword.required')}
              validations={cannotBeBlank}
              valid={this.state.current_password.valid}
              onValidateFunction={this.onUserInput.bind(this)}
              value={currentPasswordValue}
              handleChange={this.handleCurrentPasswordChange.bind(this)}
              activeState={this.props.activeState}
            />
            <ConfirmableFieldPair
              handleChange={this.onUserInput.bind(this)}
              valid={passwordConfirmed}
              validations={min8Characters}
              passwordConfirmed={passwordConfirmed}
              passwordInputClass={this.state.password.inputClass}
              passwordValue={this.state.password.value}
              passwordConfirmedClass={this.state.password_confirmation.inputClass}
              passwordConfirmationValue={this.state.password_confirmation.value}
              activeState={this.props.activeState}
            />
            <div>
              <input 
                name="login" 
                type="submit" 
                defaultValue={this.props.t('AccountPassword.save_changes')} 
                disabled={!allValid} 
              />
            </div>
          </fieldset>
        </form>
        {statusDialogs}
      </div>
    );
  }
}

export default translate()(PasswordChange);
